import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { addEntities } from "../../entities";
import {
  CREATE_BANK_ACCOUNT_FAILURE,
  CREATE_BANK_ACCOUNT_REQUEST,
  CREATE_BANK_ACCOUNT_SUCCESS
} from "../types";

const createBankAccount = (
  accountNumber,
  accountNumberRedacted,
  isBusiness,
  routingNumber,
  type,
  user,
  method = 'ACH'
) => async (dispatch, getState, { api, schema }) => {
  try {
    dispatch(createAction(CREATE_BANK_ACCOUNT_REQUEST)());
    const account = await api.vgs.createAccountByBank(
      accountNumber,
      accountNumberRedacted,
      isBusiness,
      routingNumber,
      type,
      user,
      method
    );

    const data = normalize(account, schema.accounts);
    dispatch(addEntities(data.entities));
    dispatch(createAction(CREATE_BANK_ACCOUNT_SUCCESS)(account));
    return account;
  } catch (err) {
    dispatch(createAction(CREATE_BANK_ACCOUNT_FAILURE)(err));
    throw err;
  }
};

export default createBankAccount;
